import { render, staticRenderFns } from "./grid-switch.vue?vue&type=template&id=efea325c&scoped=true&"
import script from "./grid-switch.vue?vue&type=script&lang=js&"
export * from "./grid-switch.vue?vue&type=script&lang=js&"
import style0 from "./grid-switch.vue?vue&type=style&index=0&id=efea325c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efea325c",
  null
  
)

export default component.exports